export const imgSplash = require("../assets/logo.png");
export const imgloader = require("../assets/loader.png");
